/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};


/* ================ SLATE ================ */
window.gravity = window.gravity || {};
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// gravity functions
window.gravity = window.gravity || {};

gravity.cacheSelectors = function () {
  gravity.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

gravity.init = function () {
  $(document).foundation();

  FastClick.attach(document.body);
  gravity.cacheSelectors();
  gravity.loginForms();

  
    gravity.zoomInit($('.image-zoom .__first-image'));
    $(window).resize( function () {
      $('.image-zoom').trigger('zoom.destroy');
      gravity.zoomInit($('.image-zoom .__first-image'));
    });
  
};

gravity.cartSidebarInit = function () {
  
};

gravity.getHash = function () {
  return window.location.hash;
};

gravity.headerInit = function (section) {
  var dropdownMenu = new Foundation.DropdownMenu($('#primary-menu')),
      mobileSidebar = new Foundation.OffCanvas($('#mobileMenuSidebar'));

  gravity.cartSidebarInit();

  $('.gravity-mega-menu').each(function () {
    megaMenu = new Foundation.Dropdown($(this))
  });

  if($('#admin_bar_iframe').length) {
    $('body').addClass('admin-bar-enabled')
  }

  
    $('.header-container').css('min-height', $('#main-header').outerHeight() );
    // ScrollMagic init controller
    var controller = new ScrollMagic.Controller({globalSceneOptions: {duration: 0}});

    // ScrollMagic build scenes
    var jumpHeaderScene = new ScrollMagic.Scene({ triggerElement: '.main-content',triggerHook: 'onLeave', offset: 400})
        .on('enter', function () {
          if(!$('.header-container').hasClass('jump-header')) {
            $('.header-container').addClass('jump-header');
          }
        })
        .addTo(controller);

    var jumpHeaderDisableScene = new ScrollMagic.Scene({ triggerElement: '.main-content',triggerHook: 'onLeave', offset: -50})
        .on('leave', function () {
          $('.header-container').removeClass('jump-header');
        })
        .addTo(controller);
  
};

gravity.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {
    if (variant.featured_image) {
       $('#productImages').attr('data-featured-img', variant.featured_image.id);
       gravity.changeFeaturedImg(variant.featured_image.id);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( '<span class="money money-variant-update">' + Shopify.formatMoney(variant.price, moneyFormat) + '</span>' );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html( '<span class="money money-variant-update">' + Shopify.formatMoney(variant.compare_at_price, moneyFormat) + '</span>')
        .show();
    } else {
      $comparePrice.hide();
    }
  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
  if (variant) {
    var form = jQuery('#' + selector.domIdPrefix).closest('form');
    for (var i=0,length=variant.options.length; i<length; i++) {
      var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + escape(variant.options[i]) +'"]');
      if (radioButton.size()) {
        radioButton.get(0).checked = true;
      }
    }
  }
};

gravity.changeFeaturedImg = function (featuredImgId) {
  var newImg = featuredImgId;
  var newSlideIndex = $('#productImages div[data-img-id="'+newImg+'"]').attr('data-slick-index');
  if(newSlideIndex) {
    $('#productImages').slick('slickGoTo', newSlideIndex, false);
  }
};

gravity.loginForms = function() {
  function showRecoverPasswordForm() {
    gravity.cache.$recoverPasswordForm.show();
    gravity.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    gravity.cache.$recoverPasswordForm.hide();
    gravity.cache.$customerLoginForm.show();
  }

  gravity.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  gravity.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (gravity.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

gravity.resetPasswordSuccess = function() {
  gravity.cache.$passwordResetSuccess.show();
};


gravity.zoomInit = function (imgZoom) {
  if (imgZoom.length && $(window).width() > 1024 ) {
    imgZoom
      .parent()
      .zoom({
        url: imgZoom.parent().attr('data-zoom')
    });
  }
}

gravity.instagramFeed = function (section) {

  var instagramContainer = $(section).find('.instagram-widget'),
      photosGridContainer = $(section).find('.instagram__grid'),
      instagramLoader = $(section).find('.instagram__grid_loader');
  var photosCount = instagramContainer.attr('data-insta-count'),
      token = instagramContainer.attr('data-insta-token'),
      showCaption = instagramContainer.attr('data-insta-caption');

  if( token.length ) {
    $.ajax({
      url: 'https://api.instagram.com/v1/users/self/media/recent',
      dataType: 'jsonp',
      type: 'GET',
      data: {access_token: token, count: photosCount},
      success: function(data){
          var photoItemHtml = '';
          for( x in data.data ){
            var date = new Date(data.data[x].created_time * 1000);
            var photoTimestamp = date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric'});

            var imageResolution = data.data[x].images.standard_resolution;
            var scaleClass = imageResolution.width > imageResolution.height ? 'photo__image_y' : 'photo__image_x';

            photoItemHtml += '<div class="column"><div class="instagram__photo-wrap"><div class="instagram__photo">';
            photoItemHtml += '<a class="photo__link" href="' + data.data[x].link + '" target="_blank"></a>';
            photoItemHtml += '<img class="photo__image ' + scaleClass + '" src="' + data.data[x].images.standard_resolution.url + '">';
            photoItemHtml += '</div></div></div>';

            photosGridContainer.html(photoItemHtml);
          }
      },
      error: function(data){
          console.log(data);
      }
    });
  }
};

//GOOGLE MAP
gravity.newMap = function ( jQueryel, location ) {

  var map = new google.maps.Map(jQueryel[0], {
    zoom: 14,
    disableDefaultUI: true,
    center: location,
    scrollwheel: false,
    zoomControl: true,
    zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_CENTER
    }
  });
  var marker = new google.maps.Marker({
    position: location,
    map: map
  });

  return map;
}

gravity.geolocate = function (jQueryel) {
  var geocoder = new google.maps.Geocoder();
  var address = $(jQueryel[0]).attr('data-address-setting');

  geocoder.geocode({ address: address }, function(results, status) {
    if (status !== google.maps.GeocoderStatus.OK) {
      return false;
    }
    gravity.newMap(jQueryel, results[0].geometry.location);
  });
}

var maps_api_init = 0;
var maps_api_ready = 0;

gravity.mapsInit = function (section) {
  var map = null;
  var mapContainer = $(section).find('.map__container');
  if(mapContainer.length) {
    var api_key = $(mapContainer).attr('data-api-key');
    if(api_key.length && mapContainer.length) {
      if (!maps_api_ready) {
        maps_api_init = 1;
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + api_key
        ).done(function() {
          maps_api_ready = 1;
          $('.map__container').each(function () {
            gravity.geolocate($(this));
          });
        });
      }
    }
  }
};

//YOUTUBE VIDEOS
var youtube_api_ready = 0;

window.onYouTubeIframeAPIReady = function() {
  youtube_api_ready = 1;

  gravity.ytSectionsInit();
}

gravity.ytSectionsInit = function() {
  gravity.loadVideo();

  $('.hero-section_video').each(function () {
    loadBackgroundVideo($(this));
  });
}

gravity.videoApi = function() {
  var tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  $('body').append(tag);
};

window.onBgVideoReady = function (evt) {
  var videoData = $(evt.target.h).attr('id');

  $('#' + videoData).attr('tabindex', '-1');
  evt.target.mute();
  evt.target.playVideo();
  // evt.target.setPlaybackQuality('hd720');
}

window.onPlayerChange = function (evt) {
  if (evt.data == 0) {
    evt.target.seekTo(0);
  }
}

function getVideoOptions(evt) {
  return $('.background__video[data-id=' + evt.target.h.id + ']');
}

window.loadBackgroundVideo = gravity.loadBackgroundVideo = function (section) {
  var bg_video = $(section).find('.background__video');

  if( bg_video.length) {
    bg_video.each( function () {
      var key = $(this).attr('id')
      var video = $(this).attr('data-id');

      var args = {
        ratio: 16 / 9,
        videoId: video,
        playerVars: {
          playsinline: 1,
          cc_load_policy: 0,
          iv_load_policy: 3,
          modestbranding: 0,
          controls: 0,
          showinfo: 0,
          fs: 0,
          wmode: 'opaque',
          branding: 0,
          autoplay: 1,
          autohide: 0,
          quality: 'hd720',
          rel: 0
        },
        events: {
          onReady: onBgVideoReady,
          onStateChange: onPlayerChange
        }
      };

      var videoPlayer = new YT.Player(key, args);

      function setVideoHeight () {
        var videoContainer = $('.background__video[id="'+key+'"]');
        var videoHeight = $(window).width() * 9 / 16;

        videoWrap = videoContainer.parents('.section').first();

        if (videoWrap.outerHeight() < videoHeight) {
          videoContainer.css('width', '100%');
          videoContainer.css('height', $(window).width() * 9 / 16 );
        } else {
          videoContainer.css('width', videoWrap.outerHeight() * 16 / 9 );
          videoContainer.css('height', '200%' );
        }
      }

      setVideoHeight();
      $(window).resize( function () {
        setVideoHeight();
      });

    });
  }
}

window.onVideoReady = function(evt) {
  var videoData = getVideoOptions(evt);
  var videoCover = $('#' + evt.target.h.id).parents().first().find('.video__cover').first();
  evt.target.setPlaybackQuality('hd1080');

  videoCover.find('.video__play-button').click( function () {
    videoCover.hide();
    $('#' + evt.target.h.id).addClass('youtube-video_started');
    evt.target.playVideo();
  });
}

gravity.loadVideo = function () {
  var yt_video = $('.video-section .video__iframe');
  if( yt_video.length) {
    yt_video.each( function () {
      var key = $(this).attr('id');
      var video = $(this).attr('data-id');
      var args = {
        ratio: 16 / 9,
        videoId: video,
        playerVars: {
          iv_load_policy: 3,
          modestbranding: 1,
          rel: 0
        },
        events: {
          onReady: onVideoReady
        }
      };

      var videoPlayer = new YT.Player(key, args);

      function setVideoHeight () {
        var videoContainer = $('.video__iframe[id="'+key+'"]');
        var videoHeight = videoContainer.width() * 9 / 16;
        videoContainer.css('height', videoHeight);
      }

      setVideoHeight();
      $(window).resize( function () { setVideoHeight(); });
    });
  }
}

gravity.productPageLoad = function (section) {
  var productImages = $('#productImages'),
  infoTabs = $(section).find('#ProductTabs');

  if(infoTabs.length) {
    descriptionTabs = new Foundation.Tabs(infoTabs);
  }

  // Product Images Carousel
  if(productImages.length && productImages.first().hasClass('is-carousel')) {

    if($('.product-page_default').length) {
      if(productImages.find('.product-image__slide').length > 2 ) {
        var slidesVisible = 3;
      } {
        var slidesVisible = 1;
      }

      productImages.slick({
         arrows: false,
         mobileFirst: true,
         centerMode: true,
         centerPadding: '50px',
         adaptiveHeight: true,
         slidesToShow: 1,
         focusOnSelect: true,
         infinite: false,
         responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: slidesVisible,
              variableWidth: true
            }
          },
          {
            breakpoint: 1024,
            settings: {
              arrows: true,
              centerMode: true,
              slidesToShow: slidesVisible,
              variableWidth: true
            }
          }
         ]
        }
      );
      $(window).on('orientationchange', function() {
        $(productImages).slick('resize');
      });
    }

    if($('.product-page_alt').length) {
      productImages.slick({
         arrows: false,
         adaptiveHeight: true,
         infinite: false,
         initialSlide: 0,
         fade: true,
         cssEase: 'linear',
         responsive: [
           {
             breakpoint: 750,
             settings: {
               arrows: false,
               centerMode: true,
               centerPadding: '40px',
               slidesToShow: 1,
               focusOnSelect: true,
               fade: false
             }
           }
         ]
      });

      $('#ProductThumbs .product__thumb').click(function () {
       var thumb = $(this)
       if(!thumb.hasClass('active')) {
         var newImageId = thumb.attr('data-thumb-id');
         gravity.changeFeaturedImg(newImageId);
       }
      });
    }

    productImages.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      
        $('.image-zoom').trigger('zoom.destroy');
        gravity.zoomInit($('.slick-slide[data-slick-index="'+nextSlide+'"] .image-zoom img').first());
      

      if($('.product-page_alt').length) {
        var newActiveThumb = $('.product__thumb:eq('+nextSlide+')');
        if (!newActiveThumb.hasClass('active')) {
          $('.product__thumb.active').removeClass('active');
          $('.product__thumb:eq('+nextSlide+')').addClass('active');
        }
      }
    });
  }
};

gravity.featuredCarousel = function (section) {
  var featuredGrid = $(section).find('.featured__grid');

  if($(featuredGrid).hasClass('featured-carousel')) {
    gravity.mobileCarouselInit($(featuredGrid));
    $(window).resize( function() {
      gravity.mobileCarouselInit($(featuredGrid));
    });
  }
}

gravity.mobileCarouselInit = function (carousel) {
  if ($(window).width() > 768) {
    if (carousel.hasClass('slick-initialized')) {
      carousel.slick('unslick');
    }
  }
  if (!carousel.hasClass('slick-initialized')) {
    carousel.slick({
      adaptiveHeight: true,
      infinite: false,
      mobileFirst: true,
      arrows: false,
      centerMode: true,
      centerPadding: '50px',
      slidesToShow: 1,
      focusOnSelect: true,
      responsive: [
       {
         breakpoint: 750,
         settings: "unslick"
       }
      ]
    });
  }
}

//Content Animations
var scrollMagicController = new ScrollMagic.Controller();

gravity.animateAppear = function (element, appearStyle) {
  elem = $(element).get(0);

  if ($(elem).length) {
    switch (appearStyle) {
      case 'show':
        var tween = TweenMax.to(elem, 0.7, {opacity:1});
        break;
      case 'up':
        var tween = TweenMax.fromTo(elem, 0.5, {y:'50px'}, {opacity:1, y:0});
        break;
      case 'left':
        var tween = TweenMax.fromTo(elem, 0.7, {x:'-50px'}, {opacity:1, x:0});
        break;
      case 'right':
        var tween = TweenMax.fromTo(elem, 0.7, {x:'50px'}, {opacity:1, x:0});
        break;
      default:
        break;
    }

    var showScene = new ScrollMagic.Scene({
        offset: 30,
        triggerElement: elem,
        reverse: false,
        triggerHook: 1
    })
      .setTween(tween)
      .addTo(scrollMagicController);
  }
};

gravity.pageSections = function (section) {
  //Featured Products
  $('div[data-block-type="featured-products"]').each(function () {
    gravity.featuredCarousel($(this));
  });

  //Instagram Feed
  $(section).find('div[data-block-type="instagram-feed"]').each(function () {
    gravity.instagramFeed($(this));
  });

  //Google Maps
  $('div[data-block-type="google-map"]').each(function () {
    if (maps_api_ready) {
      $('.map__container').each(function () {
        gravity.geolocate($(this));
      });
    } else {
      if (!maps_api_init) {
        gravity.mapsInit($(this));
      }
    }
  });

  //Embedded product
  $('.product-page_embedded').each(function () {
    gravity.productPageLoad($(this));
  });

  //YouTube videos
  if ($('.background__video, .video__iframe').length) {
    if (youtube_api_ready) {
      if ($('div[data-block-type="youtube-video"]').length ) {
        gravity.loadVideo();
      }
      $('div[data-block-type="hero"]').each(function () {
        if($(this).hasClass('hero-section_video')) {
          gravity.loadBackgroundVideo($(this));
        }
      });
    } else {
      if (!$('script[src="https://www.youtube.com/iframe_api"]').length) {
        gravity.videoApi();
      }
    }
  }

  gravity.animatedIconsInit();
};

/*============================================================================
  Animated Icons
==============================================================================*/
gravity.animatedIconsInit = function () {
  
}

/*============================================================================
  Sections Init
==============================================================================*/
var sections = new theme.Sections();

$(document).ready(function() {
  gravity.init();

  sections.register('hero', function (section) {
    if( $(section).hasClass('hero-section_video')) {
      if (youtube_api_ready) {
        gravity.loadBackgroundVideo(section);
      } else {
        if (!$('script[src="https://www.youtube.com/iframe_api"]').length) {
          gravity.videoApi();
        }
      }
    }
  });

  sections.register('header', function (section) {
    var headerAttrs = JSON.stringify(getAttributes($('#shopify-section-header')));
    if (headerAttrs.indexOf("data-theme-editor-section") >= 0) {
      if(!$('body').hasClass('editor-page')) {
        $('body').addClass('editor-page');
      }
    }
    gravity.headerInit(section);

    //Google Maps
    $('div[data-block-type="mega-menu-google-map"]').each(function () {
      if (maps_api_ready) {
        $('.map__container').each(function () {
          gravity.geolocate($(this));
        });
      } else {
        if (!maps_api_init) {
          gravity.mapsInit($(this));
        }
      }
    });

    gravity.animatedIconsInit();
  });

  sections.register('product-page', function (section) {
    gravity.productPageLoad(section);
  });

  sections.register('featured-products', function (section) {
    gravity.featuredCarousel(section);
  });

  sections.register('related-products', function (section) {
    gravity.featuredCarousel(section);
  });

  sections.register('featured-collections', function (section) {
    gravity.featuredCarousel(section);
  });

  sections.register('instagram-feed', function (section) {
    gravity.instagramFeed(section);
  });

  sections.register('google-map', function (section) {
    if (maps_api_ready) {
      $('.map__container').each(function () {
        gravity.geolocate($(this));
      });
    } else {
      if (!maps_api_init) {
        gravity.mapsInit(section);
      }
    }
  });

  var pageTemplateSection = sections.register('page-template', function (section) {
    gravity.pageSections(section);
  });

  sections.register('youtube-video', function (section) {
    if (youtube_api_ready) {
      gravity.loadVideo();
    } else {
      if (!$('script[src="https://www.youtube.com/iframe_api"]').length) {
        gravity.videoApi();
      }
    }
  });

  function getAttributes ( $node ) {
    var attrs = {};
    $.each($node[0].attributes, function ( index, attribute ) {
      attrs[attribute.name] = attribute.value;
    });
    return attrs;
  }

  $(document).on('shopify:section:select', function () {
    if(!$('body').hasClass('editor-page')) {
      $('body').addClass('editor-page');
    }
  });

  if(!$('editor-page').length) {
    $('.js-animate-appear-left').each(function(index, elem){
      gravity.animateAppear(elem, 'left');
    });

    $('.js-animate-appear-right').each(function(index, elem){
      gravity.animateAppear(elem, 'right');
    });

    $('.js-animate-appear-show').each(function(index, elem){
      gravity.animateAppear(elem, 'show');
    });

    $('.js-animate-appear-up').each(function(index, elem){
      gravity.animateAppear(elem, 'up');
    });
  }

  if($('.editor-page').length) {
    sections.register('features', function (section) {
      gravity.animatedIconsInit();
    });
    sections.register('image-text', function (section) {
      gravity.animatedIconsInit();
    });
    sections.register('cta-section', function (section) {
      gravity.animatedIconsInit();
    });
  }
});



/* Bijt TCG conversion and accessibility enhancements */
(function () {
  'use strict';

  function addStyles() {
    if (document.getElementById('bijt-enhancement-styles')) return;
    var style = document.createElement('style');
    style.id = 'bijt-enhancement-styles';
    style.textContent = [
      '.hero-section{position:relative!important}',
      '.bijt-hero-copy{position:absolute;z-index:3;left:50%;bottom:24px;transform:translateX(-50%);width:min(760px,calc(100% - 32px));padding:22px 26px;text-align:center;background:rgba(10,10,18,.86);border:1px solid rgba(184,154,255,.48);border-radius:16px;box-shadow:0 16px 45px rgba(0,0,0,.45);backdrop-filter:blur(8px)}',
      '.bijt-hero-copy h2{margin:0 0 8px!important;font-size:30px!important;line-height:1.15!important;color:#fff!important}.bijt-hero-copy p{margin:0 0 16px;color:#d4d0f5;font-size:16px;line-height:1.5}',
      '.bijt-hero-actions{display:flex;justify-content:center;gap:12px;flex-wrap:wrap}.bijt-hero-btn{display:inline-flex!important;align-items:center;justify-content:center;min-height:46px;padding:12px 20px!important;border-radius:9px!important;font-weight:700!important;text-decoration:none!important;color:#fff!important;background:linear-gradient(135deg,var(--bijt-purple),var(--bijt-purple-dark))!important;box-shadow:0 8px 24px rgba(155,89,232,.28)}.bijt-hero-btn--secondary{background:#1e1e2c!important;border:1px solid var(--bijt-purple)!important}',
      '.bijt-product-facts{margin:18px 0;padding:18px;background:#1e1e2c;border:1px solid var(--bijt-border);border-radius:12px}.bijt-product-facts h2{margin:0 0 12px!important;font-size:18px!important}.bijt-product-facts ul{list-style:none;margin:0;padding:0}.bijt-product-facts li{display:flex;justify-content:space-between;gap:18px;padding:9px 0;border-bottom:1px solid rgba(155,89,232,.15)}.bijt-product-facts li:last-child{border-bottom:0}.bijt-product-facts strong{color:#e8e6ff}.bijt-product-facts span{color:#c8c4f0;text-align:right}.bijt-product-help{margin:13px 0 0!important;font-size:14px}.bijt-product-help a{color:var(--bijt-purple-light)!important;text-decoration:underline}',
      '.bijt-collection-tools{display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap;margin:0 0 22px;padding:14px;background:#1e1e2c;border:1px solid var(--bijt-border);border-radius:12px}.bijt-filter-links{display:flex;gap:8px;flex-wrap:wrap}.bijt-filter-link{display:inline-flex;padding:9px 13px!important;border:1px solid rgba(155,89,232,.5);border-radius:8px!important;text-decoration:none!important;color:#d4d0f5!important;font-weight:600;font-size:13px}.bijt-filter-link:hover,.bijt-filter-link[aria-current="page"]{background:var(--bijt-purple)!important;color:#fff!important}.bijt-language-filter{display:none;align-items:center;gap:8px;flex-wrap:wrap;padding:6px 8px;border:1px solid rgba(155,89,232,.22);border-radius:10px;background:rgba(15,15,24,.38)}.bijt-language-filter.is-visible{display:flex}.bijt-language-label{color:#aaa6d8;font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:.04em}.bijt-language-link{display:inline-flex;padding:7px 11px!important;border:1px solid rgba(184,154,255,.38);border-radius:8px!important;text-decoration:none!important;color:#d4d0f5!important;font-weight:700;font-size:13px}.bijt-language-link:hover,.bijt-language-link[aria-current="page"]{background:var(--bijt-purple)!important;color:#fff!important}.bijt-sidebar-singles-title{margin-top:10px!important;color:#aaa6d8!important;font-size:12px!important;font-weight:800!important;text-transform:uppercase!important;letter-spacing:.04em!important}.bijt-sidebar-language-link{display:block!important;margin-left:12px!important;padding-left:10px!important;border-left:2px solid rgba(155,89,232,.35)!important}.bijt-sort-label{display:flex;align-items:center;gap:8px;color:#d4d0f5;font-size:13px;font-weight:600}.bijt-sort-label select{width:auto!important;margin:0!important;padding:8px 34px 8px 10px!important}',
      '@media(max-width:1023px){#shopify-section-1544503898298 .hero-section{min-height:500px!important}}',
      '@media(max-width:767px){#shopify-section-1544503898298 .hero-section{min-height:430px!important}.bijt-hero-copy{bottom:14px;padding:17px 15px}.bijt-hero-copy h2{font-size:22px!important}.bijt-hero-copy p{font-size:14px}.bijt-hero-btn{width:100%}.bijt-product-facts li{display:block}.bijt-product-facts span{display:block;margin-top:3px;text-align:left}.bijt-collection-tools{align-items:stretch}.bijt-sort-label{width:100%;justify-content:space-between}}'
    ].join('');
    document.head.appendChild(style);
  }

  function improveNavigation() {
    document.querySelectorAll('a[href="/policies/contact-information"]').forEach(function (link) {
      link.setAttribute('href', '/pages/contact');
    });
    document.querySelectorAll('a[href="/search"]').forEach(function (link) {
      link.setAttribute('aria-label', 'Zoeken');
      link.setAttribute('title', 'Zoeken');
    });
    var newsletterButton = document.querySelector('footer form button[type="submit"], footer form input[type="submit"]');
    if (newsletterButton) newsletterButton.setAttribute('aria-label', 'Inschrijven voor nieuwsbrief');
    var themeCredit = document.querySelector('footer a[href*="outlane.co"]');
    if (themeCredit) {
      themeCredit.setAttribute('href', '/');
      themeCredit.textContent = 'Bijt TCG';
    }
    document.querySelectorAll('footer p').forEach(function (paragraph) {
      Array.from(paragraph.childNodes).forEach(function (node) {
        if (node.nodeType === 3 && node.textContent.indexOf('BTW:') !== -1) {
          node.textContent = node.textContent.replace(/\s*BTW:\s*/g, ' ');
        }
      });
    });
  }

  function addHeroCopy() {
    if (location.pathname !== '/' || document.getElementById('bijt-hero-copy')) return;
    var hero = document.querySelector('#section-1544503898298 .hero-section, main .hero-section');
    if (!hero) return;
    var copy = document.createElement('div');
    copy.id = 'bijt-hero-copy';
    copy.className = 'bijt-hero-copy';
    copy.innerHTML = '<h2>Pokémon TCG – singles en sealed producten</h2><p>Ontdek zorgvuldig geselecteerde kaarten en Elite Trainer Boxen voor verzamelaars en spelers.</p><div class="bijt-hero-actions"><a class="bijt-hero-btn" href="/collections/singles">Bekijk singles</a><a class="bijt-hero-btn bijt-hero-btn--secondary" href="/collections/elite-trainer-boxen">Bekijk Elite Trainer Boxen</a></div>';
    hero.appendChild(copy);
  }

  function improveProductPage() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var quantityLabel = document.querySelector('label[for="Quantity"]');
    if (quantityLabel) quantityLabel.textContent = 'Aantal';
    var quantityInput = document.getElementById('Quantity');
    if (quantityInput) quantityInput.setAttribute('aria-label', 'Aantal');
    var addText = document.getElementById('AddToCartText');
    if (addText) addText.textContent = 'Toevoegen aan winkelwagen';
    var addButton = document.getElementById('AddToCart');
    if (addButton) addButton.setAttribute('aria-label', 'Toevoegen aan winkelwagen');
    if (document.getElementById('bijt-product-facts')) return;

    var title = (document.querySelector('.product-title, main h1') || {}).textContent || '';
    var cardCode = title.match(/\(([^)]+)\)/);
    var facts = document.createElement('section');
    facts.id = 'bijt-product-facts';
    facts.className = 'bijt-product-facts';
    facts.setAttribute('aria-labelledby', 'bijt-product-facts-title');
    var list = '<li><strong>Conditie</strong><span>Near Mint, tenzij anders vermeld</span></li>';
    if (cardCode) list += '<li><strong>Set / kaartnummer</strong><span>' + cardCode[1] + '</span></li>';
    facts.innerHTML = '<h2 id="bijt-product-facts-title">Productinformatie</h2><ul>' + list + '</ul><p class="bijt-product-help">Vragen over taal, conditie of levering? <a href="/pages/contact">Neem contact op</a> of bekijk <a href="/pages/verzending-levertijd">verzending &amp; levertijd</a>.</p>';
        if (cardCode) facts.innerHTML += '<p class="bijt-product-note"><em>Deze afbeelding is ter illustratie. De daadwerkelijke kaart kan afwijken van de afbeelding.</em></p>';
    form.parentNode.insertBefore(facts, form);
  }

  function addCollectionTools() {
    var content = document.querySelector('.collection-content');
    if (!content || document.getElementById('bijt-collection-tools')) return;
    var tools = document.createElement('nav');
    tools.id = 'bijt-collection-tools';
    tools.className = 'bijt-collection-tools';
    tools.setAttribute('aria-label', 'Producten filteren en sorteren');
    tools.innerHTML = '<div class="bijt-filter-links"><a class="bijt-filter-link" href="' + location.pathname + '">Alle producten</a><a class="bijt-filter-link" href="' + location.pathname + '?filter.v.availability=1">Op voorraad</a></div><label class="bijt-sort-label" for="bijt-sort">Sorteren <select id="bijt-sort"><option value="manual">Aanbevolen</option><option value="price-ascending">Prijs: laag naar hoog</option><option value="price-descending">Prijs: hoog naar laag</option><option value="created-descending">Nieuwste eerst</option></select></label>';
    content.insertBefore(tools, content.firstChild);
    var currentPath = location.pathname;
    tools.querySelectorAll('.bijt-filter-link').forEach(function (link) {
      var linkUrl = new URL(link.href);
      if ((linkUrl.pathname === currentPath && !linkUrl.search) || (linkUrl.search && linkUrl.search === location.search)) link.setAttribute('aria-current', 'page');
    });
    var sort = tools.querySelector('#bijt-sort');
    var params = new URLSearchParams(location.search);
    sort.value = params.get('sort_by') || 'manual';
    sort.addEventListener('change', function () {
      var next = new URL(location.href);
      if (sort.value === 'manual') next.searchParams.delete('sort_by');
      else next.searchParams.set('sort_by', sort.value);
      location.href = next.toString();
    });
  }

  function refineSinglesCollectionFilters() {
    var path = location.pathname;
    if (!/^\/collections\//.test(path)) return;

    var containers = Array.from(document.querySelectorAll('.collection-sidebar, .product-collections-widget'));
    if (!containers.length) containers = Array.from(document.querySelectorAll('main'));

    containers.forEach(function (container) {
      if (!container || container.querySelector('.bijt-sidebar-singles-title')) return;

      var links = Array.from(container.querySelectorAll('a[href="/collections/singles"], a[href="/collections/singles-japans"]')).filter(function (link) {
        return !link.closest('#bijt-collection-tools') && !link.closest('.product-loop-card') && !link.classList.contains('product-loop-title') && !link.classList.contains('product-loop-price');
      });
      if (!links.length) return;

      links.sort(function (a, b) {
        return a.compareDocumentPosition(b) & 2 ? 1 : -1;
      });

      var first = links[0];
      var title = document.createElement('a');
      title.className = 'bijt-sidebar-singles-title';
      title.href = '/collections/singles';
      title.textContent = 'Singles';
      if (path === '/collections/singles' || path === '/collections/singles-japans') title.setAttribute('aria-current', 'page');
      first.parentNode.insertBefore(title, first);

      links.forEach(function (link) {
        var href = link.getAttribute('href');
        link.textContent = href === '/collections/singles-japans' ? 'Japans' : 'Engels';
        link.classList.add('bijt-sidebar-language-link');
        link.removeAttribute('aria-current');
        if (href === path) link.setAttribute('aria-current', 'page');
      });
    });
  }

  function initialiseBijtEnhancements() {
    addStyles();
    improveNavigation();
    addHeroCopy();
    improveProductPage();
    addCollectionTools();
    refineSinglesCollectionFilters();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseBijtEnhancements);
  else initialiseBijtEnhancements();
  window.setTimeout(initialiseBijtEnhancements, 800);
  window.setTimeout(initialiseBijtEnhancements, 2200);
})();



/* Correct active collection filter when query parameters are present */
(function () {
  function markActiveBijtFilter() {
    var tools = document.getElementById('bijt-collection-tools');
    if (!tools) return;
    var current = new URL(location.href);
    current.searchParams.delete('sort_by');
    tools.querySelectorAll('.bijt-filter-link').forEach(function (link) {
      link.removeAttribute('aria-current');
      var target = new URL(link.href);
      target.searchParams.delete('sort_by');
      if (target.pathname === current.pathname && target.search === current.search) {
        link.setAttribute('aria-current', 'page');
      }
    });
  }
  window.setTimeout(markActiveBijtFilter, 2400);
})();



/* Keep mobile navigation controls compact */
(function () {
  if (document.getElementById('bijt-mobile-menu-controls')) return;
  var style = document.createElement('style');
  style.id = 'bijt-mobile-menu-controls';
  style.textContent = '@media(max-width:1023px){button.close-button{position:absolute!important;top:10px!important;right:10px!important;left:auto!important;width:36px!important;height:36px!important;min-width:36px!important;margin:0!important;padding:0!important;background:transparent!important;border:1px solid rgba(184,154,255,.35)!important;border-radius:50%!important;box-shadow:none!important;transform:none!important;overflow:visible!important;font-size:26px!important;line-height:1!important;text-transform:none!important;letter-spacing:0!important}button.close-button:hover{background:rgba(155,89,232,.15)!important;box-shadow:none!important;transform:none!important}button.close-button::before,button.close-button::after{content:none!important;display:none!important}button.submenu-toggle{position:absolute!important;top:50%!important;right:8px!important;left:auto!important;width:30px!important;height:30px!important;min-width:30px!important;margin:0!important;padding:0!important;background:rgba(155,89,232,.12)!important;border:1px solid rgba(184,154,255,.32)!important;border-radius:6px!important;box-shadow:none!important;transform:translateY(-50%)!important;overflow:hidden!important;text-transform:none!important;letter-spacing:0!important}button.submenu-toggle:hover{background:rgba(155,89,232,.22)!important;box-shadow:none!important;transform:translateY(-50%)!important}button.submenu-toggle::before{content:none!important;display:none!important}}';
  document.head.appendChild(style);
})();


/* Place the homepage CTA below the hero banner */
(function () {
  function placeBijtHeroCta() {
    var card = document.getElementById('bijt-hero-copy');
    var hero = document.querySelector('.hero-section');
    if (!card || !hero) return;

    if (card.previousElementSibling !== hero) {
      hero.insertAdjacentElement('afterend', card);
    }

    if (!document.getElementById('bijt-hero-below-banner')) {
      var style = document.createElement('style');
      style.id = 'bijt-hero-below-banner';
      style.textContent = '.bijt-hero-copy{position:relative!important;z-index:2!important;left:auto!important;bottom:auto!important;transform:none!important;width:min(760px,calc(100% - 32px))!important;margin:28px auto 36px!important}@media(max-width:767px){.bijt-hero-copy{margin:20px auto 30px!important}}';
      document.head.appendChild(style);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeBijtHeroCta);
  } else {
    placeBijtHeroCta();
  }
  window.setTimeout(placeBijtHeroCta, 1000);
  window.setTimeout(placeBijtHeroCta, 2400);
})();

/* Translate the contact form into Dutch */
(function () {
  function translateBijtContactForm() {
    if (location.pathname !== '/pages/contact') return;

    var replacements = {
      'Contact Form': 'Contact opnemen',
      'Send us a message and we will get back to you within 24 hours.': 'Stuur ons een bericht. We reageren zo snel mogelijk, meestal binnen 1-2 werkdagen.',
      "Thanks for contacting us. We'll get back to you as soon as possible.": 'Bedankt voor je bericht. We nemen zo snel mogelijk contact met je op.',
      'Please adjust the following:': 'Controleer de volgende velden:'
    };

    document.querySelectorAll('h1, h2, h3, h4, p, .form-success, .errors li').forEach(function (element) {
      var text = element.textContent.trim();
      if (replacements[text]) element.textContent = replacements[text];
    });

    var submit = document.querySelector('#contact_form input[type="submit"]');
    if (submit) {
      submit.value = 'Bericht versturen';
      submit.setAttribute('aria-label', 'Bericht versturen');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateBijtContactForm);
  } else {
    translateBijtContactForm();
  }
  window.setTimeout(translateBijtContactForm, 1000);
})();

/* Homepage trust bar and restock newsletter messaging */
(function () {
  function addBijtTrustElements() {
    if (location.pathname === '/' && !document.getElementById('bijt-trust-bar')) {
      var cta = document.getElementById('bijt-hero-copy');
      if (cta) {
        var bar = document.createElement('section');
        bar.id = 'bijt-trust-bar';
        bar.setAttribute('aria-label', 'Voordelen van bestellen bij Bijt TCG');
        bar.innerHTML = '<a class="bijt-trust-item" href="/pages/verzending-levertijd"><span class="bijt-trust-icon" aria-hidden="true">✓</span><span><strong>Gratis verzending</strong><small>Bij bestellingen vanaf €250</small></span></a><a class="bijt-trust-item" href="/pages/verzending-levertijd"><span class="bijt-trust-icon" aria-hidden="true">✓</span><span><strong>Snel verzonden</strong><small>Voor 12:00 besteld, vandaag verzonden</small></span></a><div class="bijt-trust-item"><span class="bijt-trust-icon" aria-hidden="true">✓</span><span><strong>Veilig betalen</strong><small>Via vertrouwde betaalmethoden</small></span></div>';
        cta.insertAdjacentElement('afterend', bar);
      }
    }

    document.querySelectorAll('footer h3').forEach(function (heading) {
      if (heading.textContent.trim() === 'Schrijf je in voor de nieuwsbrief') {
        heading.textContent = 'Blijf op de hoogte van restocks';
        var description = heading.nextElementSibling;
        if (description && description.tagName === 'P') {
          description.textContent = 'Ontvang updates over nieuwe Pokémon-producten, restocks en exclusieve drops.';
        }
      }
    });

    if (!document.getElementById('bijt-trust-styles')) {
      var style = document.createElement('style');
      style.id = 'bijt-trust-styles';
      style.textContent = '#bijt-trust-bar{display:grid;grid-template-columns:repeat(3,1fr);width:min(1100px,calc(100% - 32px));margin:0 auto 40px;background:#151522;border:1px solid rgba(184,154,255,.34);border-radius:14px;box-shadow:0 12px 32px rgba(0,0,0,.24);overflow:hidden}.bijt-trust-item{display:flex!important;align-items:center;gap:12px;min-height:82px;padding:16px 20px!important;color:#f4f2ff!important;text-decoration:none!important;background:transparent!important}.bijt-trust-item+.bijt-trust-item{border-left:1px solid rgba(184,154,255,.18)}a.bijt-trust-item:hover{background:rgba(155,89,232,.10)!important}.bijt-trust-icon{display:inline-flex;align-items:center;justify-content:center;flex:0 0 34px;width:34px;height:34px;border-radius:50%;background:rgba(155,89,232,.16);border:1px solid rgba(184,154,255,.45);color:#c6a7ff;font-size:18px;font-weight:800}.bijt-trust-item strong,.bijt-trust-item small{display:block}.bijt-trust-item strong{margin-bottom:3px;color:#fff;font-size:15px;line-height:1.3}.bijt-trust-item small{color:#c9c5df;font-size:12px;line-height:1.4}@media(max-width:767px){#bijt-trust-bar{grid-template-columns:1fr;margin-bottom:30px}.bijt-trust-item{min-height:70px;padding:13px 16px!important}.bijt-trust-item+.bijt-trust-item{border-left:0;border-top:1px solid rgba(184,154,255,.18)}}';
      document.head.appendChild(style);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addBijtTrustElements);
  } else {
    addBijtTrustElements();
  }
  window.setTimeout(addBijtTrustElements, 1000);
})();

/* Ensure the restock newsletter description is updated */
(function () {
  function updateBijtRestockDescription() {
    document.querySelectorAll('footer h3').forEach(function (heading) {
      if (heading.textContent.trim() === 'Blijf op de hoogte van restocks') {
        var paragraph = heading.parentElement ? heading.parentElement.querySelector('p') : null;
        if (paragraph) paragraph.textContent = 'Ontvang updates over nieuwe Pokémon-producten, restocks en exclusieve drops.';
      }
    });
  }
  updateBijtRestockDescription();
  window.setTimeout(updateBijtRestockDescription, 1200);
})();

/* Replace the large image banner with a compact branded hero */
(function () {
  function buildBijtCompactHero() {
    if (location.pathname !== '/') return;

    var section = document.getElementById('section-1544503898298');
    var imageHero = section ? section.querySelector('.hero-section') : null;
    var card = document.getElementById('bijt-hero-copy');
    if (imageHero) imageHero.style.setProperty('display', 'none', 'important');
    if (!card) return;

    card.classList.add('bijt-compact-hero');
    var heading = card.querySelector('h2'); if (heading) { var h1 = document.createElement('h1'); h1.className = heading.className; heading.parentNode.replaceChild(h1, heading); heading = h1; }
    var paragraph = card.querySelector('p');
    if (heading) heading.textContent = 'Pokémon TCG voor verzamelaars en spelers';
    if (paragraph) paragraph.textContent = 'Ontdek zorgvuldig geselecteerde singles en sealed producten, met aandacht voor kwaliteit, conditie en snelle verzending.';

    if (!card.querySelector('.bijt-hero-kicker')) {
      var kicker = document.createElement('div');
      kicker.className = 'bijt-hero-kicker';
      kicker.textContent = 'SINGLES  •  SEALED  •  POKÉMON TCG';
      card.insertBefore(kicker, card.firstChild);
    }

    if (!document.getElementById('bijt-compact-hero-styles')) {
      var style = document.createElement('style');
      style.id = 'bijt-compact-hero-styles';
      style.textContent = '#section-1544503898298{padding:46px 0 12px!important;background:radial-gradient(circle at 16% 12%,rgba(155,89,232,.13),transparent 30%),radial-gradient(circle at 84% 18%,rgba(106,62,181,.12),transparent 32%),linear-gradient(180deg,#11111b 0%,#0c0c13 100%)!important;overflow:hidden}#section-1544503898298 .hero-section{display:none!important}#section-1544503898298 .bijt-compact-hero{position:relative!important;left:auto!important;bottom:auto!important;transform:none!important;width:min(1100px,calc(100% - 32px))!important;margin:0 auto 24px!important;padding:52px 34px!important;overflow:hidden;background:radial-gradient(circle at 12% 25%,rgba(155,89,232,.20),transparent 34%),radial-gradient(circle at 88% 72%,rgba(99,55,180,.17),transparent 32%),linear-gradient(145deg,rgba(28,27,43,.98),rgba(11,11,19,.98))!important;border:1px solid rgba(184,154,255,.46)!important;border-radius:18px!important;box-shadow:0 20px 55px rgba(0,0,0,.34)!important;backdrop-filter:none!important}#section-1544503898298 .bijt-compact-hero:before,#section-1544503898298 .bijt-compact-hero:after{content:"";position:absolute;border:1px solid rgba(184,154,255,.10);border-radius:28px;transform:rotate(24deg);pointer-events:none}#section-1544503898298 .bijt-compact-hero:before{width:180px;height:245px;left:-75px;top:-95px}#section-1544503898298 .bijt-compact-hero:after{width:150px;height:210px;right:-58px;bottom:-88px}#section-1544503898298 .bijt-compact-hero>*{position:relative;z-index:1}.bijt-hero-kicker{margin:0 0 13px;color:#c4a3ff;font-size:12px;font-weight:800;letter-spacing:2px}.bijt-compact-hero h2{max-width:850px;margin:0 auto 12px!important;font-size:38px!important;line-height:1.12!important}.bijt-compact-hero p{max-width:720px;margin:0 auto 22px!important;font-size:17px!important;line-height:1.55!important}.bijt-compact-hero .bijt-hero-actions{gap:14px}.bijt-compact-hero .bijt-hero-btn{min-width:190px}.bijt-compact-hero+#bijt-trust-bar{margin-top:0}@media(max-width:767px){#section-1544503898298{padding:20px 0 8px!important}#section-1544503898298 .bijt-compact-hero{padding:34px 18px!important;margin-bottom:18px!important;border-radius:15px!important}.bijt-hero-kicker{font-size:10px;letter-spacing:1.3px}.bijt-compact-hero h2{font-size:27px!important;line-height:1.16!important}.bijt-compact-hero p{font-size:14px!important;margin-bottom:18px!important}.bijt-compact-hero .bijt-hero-btn{min-width:0}}';
      document.head.appendChild(style);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildBijtCompactHero);
  } else {
    buildBijtCompactHero();
  }
  window.setTimeout(buildBijtCompactHero, 1000);
})();

/* Add Accessories as the third homepage CTA */
(function () {
  function addBijtAccessoriesButton() {
    if (location.pathname !== '/') return;
    var actions = document.querySelector('#bijt-hero-copy .bijt-hero-actions');
    if (!actions || document.getElementById('bijt-accessories-cta')) return;

    var button = document.createElement('a');
    button.id = 'bijt-accessories-cta';
    button.className = 'bijt-hero-btn bijt-hero-btn--secondary';
    button.href = '/collections/accessoires';
    button.textContent = 'Bekijk accessoires';
    actions.appendChild(button);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addBijtAccessoriesButton);
  } else {
    addBijtAccessoriesButton();
  }
  window.setTimeout(addBijtAccessoriesButton, 1000);
})();

/* Give all three homepage CTA buttons the same layout */
(function () {
  if (document.getElementById('bijt-equal-cta-styles')) return;
  var style = document.createElement('style');
  style.id = 'bijt-equal-cta-styles';
  style.textContent = '#bijt-hero-copy .bijt-hero-actions .bijt-hero-btn{flex:0 0 230px!important;width:230px!important;min-width:230px!important;min-height:50px!important;padding:13px 18px!important;background:linear-gradient(135deg,#a855f7,#7c3aed)!important;border:1px solid rgba(205,177,255,.55)!important;border-radius:9px!important;color:#fff!important;box-shadow:0 8px 24px rgba(155,89,232,.30)!important;transform:none!important}#bijt-hero-copy .bijt-hero-actions .bijt-hero-btn:hover{background:linear-gradient(135deg,#b667ff,#8b4cf2)!important;box-shadow:0 11px 28px rgba(155,89,232,.40)!important;transform:translateY(-2px)!important}@media(max-width:767px){#bijt-hero-copy .bijt-hero-actions .bijt-hero-btn{flex:1 1 auto!important;width:100%!important;min-width:0!important}}';
  document.head.appendChild(style);
})();

/* Keep all homepage CTA labels on one equal line */
(function () {
  if (document.getElementById('bijt-cta-size-polish')) return;
  var style = document.createElement('style');
  style.id = 'bijt-cta-size-polish';
  style.textContent = '@media(min-width:768px){#bijt-hero-copy .bijt-hero-actions .bijt-hero-btn{flex-basis:260px!important;width:260px!important;min-width:260px!important;height:52px!important;min-height:52px!important;padding:0 18px!important;line-height:1.2!important;white-space:nowrap!important}}';
  document.head.appendChild(style);
})();

/* Add a dynamic Accessories product section to the homepage */
(function () {
  function addBijtAccessoriesSection() {
    if (location.pathname !== '/' || document.getElementById('bijt-accessories-products')) return;
    var singlesSection = document.getElementById('shopify-section-featured_products_NFf67p');
    if (!singlesSection) return;

    fetch('/collections/accessoires')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        if (document.getElementById('bijt-accessories-products')) return;
        var source = new DOMParser().parseFromString(html, 'text/html');
        var cards = Array.prototype.slice.call(source.querySelectorAll('.product-loop-item'), 0, 4);
        if (!cards.length) return;

        var wrapper = document.createElement('div');
        wrapper.id = 'bijt-accessories-products';
        wrapper.className = 'shopify-section';
        wrapper.innerHTML = '<div class="section"><div data-section-type="featured-products" class="content-section featured-products section__background"><div class="content-section__inner"><div class="row columns text-center"><h2 class="section-title section__title-style">Pokémon accessoires</h2></div><div class="featured__grid__wrap"><div class="row small-up-2 medium-up-4 large-up-6 featured__grid bijt-accessories-grid"></div></div><div class="bijt-accessories-footer"><a class="bijt-accessories-view-all" href="/collections/accessoires">Bekijk alle accessoires</a></div></div></div></div>';

        var grid = wrapper.querySelector('.bijt-accessories-grid');
        cards.forEach(function (card) {
          card.removeAttribute('aria-hidden');
          card.removeAttribute('tabindex');
          card.querySelectorAll('a').forEach(function (link) { link.removeAttribute('tabindex'); });
          card.querySelectorAll('img').forEach(function (image) {
            var sourceUrl = image.getAttribute('data-src');
            var sourceSet = image.getAttribute('data-srcset');
            if (sourceUrl) image.setAttribute('src', sourceUrl);
            if (sourceSet) image.setAttribute('srcset', sourceSet);
            image.classList.remove('lazyload');
            image.classList.add('lazyloaded');
          });
          grid.appendChild(card);
        });

        singlesSection.insertAdjacentElement('afterend', wrapper);

        if (!document.getElementById('bijt-accessories-section-styles')) {
          var style = document.createElement('style');
          style.id = 'bijt-accessories-section-styles';
          style.textContent = '#bijt-accessories-products .content-section{padding:20px 0 34px;background:#020004}#bijt-accessories-products .section-title{margin-bottom:28px!important;font-size:28px!important;color:#fff!important}#bijt-accessories-products .featured__grid__wrap{opacity:1}#bijt-accessories-products .bijt-accessories-footer{text-align:center;margin-top:18px}.bijt-accessories-view-all{display:inline-flex!important;align-items:center;justify-content:center;min-height:48px;padding:12px 22px!important;border-radius:9px!important;background:linear-gradient(135deg,#a855f7,#7c3aed)!important;border:1px solid rgba(205,177,255,.55)!important;color:#fff!important;font-weight:700!important;text-decoration:none!important;box-shadow:0 8px 24px rgba(155,89,232,.28)!important}.bijt-accessories-view-all:hover{background:linear-gradient(135deg,#b667ff,#8b4cf2)!important;transform:translateY(-2px)!important;box-shadow:0 11px 28px rgba(155,89,232,.38)!important}@media(max-width:767px){#bijt-accessories-products .content-section{padding-bottom:28px}#bijt-accessories-products .section-title{font-size:25px!important;margin-bottom:22px!important}.bijt-accessories-view-all{width:calc(100% - 32px)}}';
          document.head.appendChild(style);
        }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addBijtAccessoriesSection);
  } else {
    addBijtAccessoriesSection();
  }
  window.setTimeout(addBijtAccessoriesSection, 1400);
})();

/* Resolve dynamic image sizes in the Accessories homepage section */
(function () {
  function fixBijtAccessoriesImages() {
    var section = document.getElementById('bijt-accessories-products');
    if (!section) return;
    section.querySelectorAll('img').forEach(function (image) {
      ['src', 'data-src', 'srcset', 'data-srcset'].forEach(function (attribute) {
        var value = image.getAttribute(attribute);
        if (value) {
          value = value.replace(/\{width\}/g, '600').replace(/%7Bwidth%7D/gi, '600');
          image.setAttribute(attribute, value);
        }
      });
      image.style.width = '100%';
      image.style.aspectRatio = '1 / 1';
      image.style.objectFit = 'cover';
      image.classList.remove('lazyload');
      image.classList.add('lazyloaded');
    });
  }
  fixBijtAccessoriesImages();
  window.setTimeout(fixBijtAccessoriesImages, 900);
  window.setTimeout(fixBijtAccessoriesImages, 2200);
})();

/* Expand the Accessories homepage section to six products */
(function () {
  function prepareBijtAccessoryCard(card) {
    card.removeAttribute('aria-hidden');
    card.removeAttribute('tabindex');
    card.querySelectorAll('a').forEach(function (link) { link.removeAttribute('tabindex'); });
    card.querySelectorAll('img').forEach(function (image) {
      ['src', 'data-src', 'srcset', 'data-srcset'].forEach(function (attribute) {
        var value = image.getAttribute(attribute);
        if (value) image.setAttribute(attribute, value.replace(/\{width\}/g, '600').replace(/%7Bwidth%7D/gi, '600'));
      });
      image.style.width = '100%';
      image.style.aspectRatio = '1 / 1';
      image.style.objectFit = 'cover';
      image.classList.remove('lazyload');
      image.classList.add('lazyloaded');
    });
    return card;
  }

  function expandBijtAccessoriesProducts() {
    if (location.pathname !== '/') return;
    var grid = document.querySelector('#bijt-accessories-products .bijt-accessories-grid');
    if (!grid || grid.querySelectorAll('.product-loop-item').length >= 6) return;

    fetch('/collections/accessoires')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var currentGrid = document.querySelector('#bijt-accessories-products .bijt-accessories-grid');
        if (!currentGrid) return;
        var existing = {};
        currentGrid.querySelectorAll('.product-loop-title').forEach(function (link) { existing[link.getAttribute('href')] = true; });
        var source = new DOMParser().parseFromString(html, 'text/html');
        var cards = Array.prototype.slice.call(source.querySelectorAll('.product-loop-item'), 0, 6);
        cards.forEach(function (card) {
          if (currentGrid.querySelectorAll('.product-loop-item').length >= 6) return;
          var link = card.querySelector('.product-loop-title');
          var href = link ? link.getAttribute('href') : '';
          if (href && !existing[href]) {
            existing[href] = true;
            currentGrid.appendChild(prepareBijtAccessoryCard(card));
          }
        });
      })
      .catch(function () {});
  }

  expandBijtAccessoriesProducts();
  window.setTimeout(expandBijtAccessoriesProducts, 1200);
  window.setTimeout(expandBijtAccessoriesProducts, 2600);
})();

/* Prefer the native six-product Accessories section and prevent duplicates */
(function () {
  function findNativeBijtAccessoriesSection() {
    var sections = document.querySelectorAll('main .shopify-section');
    for (var i = 0; i < sections.length; i += 1) {
      if (sections[i].id === 'bijt-accessories-products') continue;
      var heading = sections[i].querySelector('h2');
      if (heading && heading.textContent.trim() === 'Accessoires') return sections[i];
    }
    return null;
  }

  function consolidateBijtAccessoriesSections() {
    var nativeSection = findNativeBijtAccessoriesSection();
    if (!nativeSection) return;
    document.body.classList.add('bijt-has-native-accessories');

    var customSection = document.getElementById('bijt-accessories-products');
    if (customSection) customSection.remove();

    var inner = nativeSection.querySelector('.content-section__inner');
    if (inner && !nativeSection.querySelector('.bijt-accessories-view-all')) {
      var footer = document.createElement('div');
      footer.className = 'bijt-accessories-footer';
      footer.innerHTML = '<a class="bijt-accessories-view-all" href="/collections/accessoires">Bekijk alle accessoires</a>';
      inner.appendChild(footer);
    }

    if (!document.getElementById('bijt-native-accessories-styles')) {
      var style = document.createElement('style');
      style.id = 'bijt-native-accessories-styles';
      style.textContent = '.bijt-has-native-accessories #bijt-accessories-products{display:none!important}.bijt-accessories-footer{text-align:center;margin-top:18px}.bijt-accessories-view-all{display:inline-flex!important;align-items:center;justify-content:center;min-height:48px;padding:12px 22px!important;border-radius:9px!important;background:linear-gradient(135deg,#a855f7,#7c3aed)!important;border:1px solid rgba(205,177,255,.55)!important;color:#fff!important;font-weight:700!important;text-decoration:none!important;box-shadow:0 8px 24px rgba(155,89,232,.28)!important}.bijt-accessories-view-all:hover{background:linear-gradient(135deg,#b667ff,#8b4cf2)!important;transform:translateY(-2px)!important}@media(max-width:767px){.bijt-accessories-view-all{width:calc(100% - 32px)}}';
      document.head.appendChild(style);
    }
  }

  consolidateBijtAccessoriesSections();
  window.setTimeout(consolidateBijtAccessoriesSections, 300);
  window.setTimeout(consolidateBijtAccessoriesSections, 1000);
  window.setTimeout(consolidateBijtAccessoriesSections, 2400);
})();

/* Disable and remove the custom Accessories product section */
(function () {
  function removeBijtCustomAccessoriesSection() {
    var customSection = document.getElementById('bijt-accessories-products');
    if (customSection) customSection.remove();
    document.querySelectorAll('.bijt-accessories-footer').forEach(function (footer) { footer.remove(); });
  }

  if (!document.getElementById('bijt-hide-custom-accessories')) {
    var style = document.createElement('style');
    style.id = 'bijt-hide-custom-accessories';
    style.textContent = '#bijt-accessories-products{display:none!important}';
    document.head.appendChild(style);
  }

  removeBijtCustomAccessoriesSection();
  window.setTimeout(removeBijtCustomAccessoriesSection, 350);
  window.setTimeout(removeBijtCustomAccessoriesSection, 1100);
  window.setTimeout(removeBijtCustomAccessoriesSection, 2500);
  window.setTimeout(removeBijtCustomAccessoriesSection, 3600);
})();

/* Add Accessories to the collection filter links */
(function () {
  function addBijtAccessoriesFilter() {
    var links = document.querySelector('.bijt-filter-links');
    if (!links) return;

    var current = new URL(location.href);
    current.searchParams.delete('sort_by');
    links.querySelectorAll('.bijt-filter-link').forEach(function (link) {
      link.removeAttribute('aria-current');
      var target = new URL(link.href);
      target.searchParams.delete('sort_by');
      if (target.pathname === current.pathname && target.search === current.search) {
        link.setAttribute('aria-current', 'page');
      }
    });
  }

  addBijtAccessoriesFilter();
  window.setTimeout(addBijtAccessoriesFilter, 900);
  window.setTimeout(addBijtAccessoriesFilter, 2400);
})();

/* Bijt TCG: sold-out popup */
(function () {
  var modalId = 'bijt-soldout-modal';
  var lastTrigger = null;
  var syncTimer = null;

  function collectionUrl() {
    var match = window.location.pathname.match(/^\/collections\/([^/]+)\/products\//);
    return match ? '/collections/' + match[1] + '?filter.v.availability=1' : '/collections/all?filter.v.availability=1';
  }

  function ensureModal() {
    var modal = document.getElementById(modalId);
    if (modal) return modal;

    var style = document.createElement('style');
    style.textContent = '.bijt-sold-out-trigger{display:block;width:100%;margin-top:12px;background:#8d42ea!important;color:#fff!important;border:0!important}.bijt-soldout-modal{position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;padding:20px}.bijt-soldout-modal.is-open{display:flex}.bijt-soldout-overlay{position:absolute;inset:0;background:rgba(4,4,10,.78);backdrop-filter:blur(4px)}.bijt-soldout-dialog{position:relative;width:min(100%,480px);padding:32px;border:1px solid rgba(168,85,247,.45);border-radius:18px;background:#24252f;color:#fff;box-shadow:0 24px 80px rgba(0,0,0,.5);text-align:center}.bijt-soldout-dialog h2{margin:6px 0 12px;font-size:28px;color:#fff}.bijt-soldout-dialog p{margin:0 0 24px;color:#d6d3e1;line-height:1.6}.bijt-soldout-eyebrow{margin-bottom:4px!important;color:#b979ff!important;font-size:12px;font-weight:700;letter-spacing:.12em;text-transform:uppercase}.bijt-soldout-close{position:absolute;top:12px;right:14px;padding:4px 10px;border:0;background:transparent;color:#fff;font-size:28px;line-height:1;cursor:pointer}.bijt-soldout-actions{display:grid;gap:10px}.bijt-soldout-link,.bijt-soldout-dismiss{display:block;width:100%;padding:14px 18px;border-radius:8px;font-weight:700;text-align:center;cursor:pointer}.bijt-soldout-link{background:#8d42ea;color:#fff!important}.bijt-soldout-dismiss{border:1px solid #555665;background:transparent;color:#fff}.bijt-modal-open{overflow:hidden}@media(max-width:480px){.bijt-soldout-dialog{padding:28px 20px}.bijt-soldout-dialog h2{font-size:23px}}';
    document.head.appendChild(style);

    modal = document.createElement('div');
    modal.id = modalId;
    modal.className = 'bijt-soldout-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = '<div class="bijt-soldout-overlay" data-bijt-close></div><div class="bijt-soldout-dialog" role="dialog" aria-modal="true" aria-labelledby="bijt-soldout-title"><button class="bijt-soldout-close" type="button" aria-label="Sluiten" data-bijt-close>&times;</button><p class="bijt-soldout-eyebrow">Bijt TCG</p><h2 id="bijt-soldout-title">Tijdelijk niet op voorraad</h2><p>Dit product is momenteel niet beschikbaar. Bekijk onze andere producten die direct op voorraad zijn.</p><div class="bijt-soldout-actions"><a class="bijt-soldout-link" href="' + collectionUrl() + '">Bekijk producten op voorraad</a><button class="bijt-soldout-dismiss" type="button" data-bijt-close>Sluiten</button></div></div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (event) {
      if (event.target.hasAttribute('data-bijt-close')) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
    return modal;
  }

  function openModal(trigger) {
    var modal = ensureModal();
    lastTrigger = trigger;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bijt-modal-open');
    window.setTimeout(function () {
      var closeButton = modal.querySelector('.bijt-soldout-close');
      if (closeButton) closeButton.focus();
    }, 20);
  }

  function closeModal() {
    var modal = document.getElementById(modalId);
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bijt-modal-open');
    if (lastTrigger) lastTrigger.focus();
  }

  function syncSoldOutButton() {
    var original = document.querySelector('form[action*="/cart/add"] .addToCartButton');
    if (!original) return;
    var soldOut = original.disabled || original.classList.contains('disabled');
    var trigger = document.querySelector('.bijt-sold-out-trigger');
    var dynamicCheckout = document.querySelector('.shopify-payment-button');

    if (soldOut) {
      original.style.display = 'none';
      if (dynamicCheckout) dynamicCheckout.style.display = 'none';
      if (!trigger) {
        trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'button bijt-sold-out-trigger';
        trigger.textContent = 'Niet op voorraad';
        trigger.addEventListener('click', function () { openModal(trigger); });
        original.parentNode.insertBefore(trigger, original.nextSibling);
      }
    } else {
      original.style.display = '';
      if (dynamicCheckout) dynamicCheckout.style.display = '';
      if (trigger && trigger.parentNode) trigger.parentNode.removeChild(trigger);
    }
  }

  function queueSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncSoldOutButton, 40);
  }

  function initSoldOutPopup() {
    if (!document.body.classList.contains('template-product')) return;
    ensureModal();
    syncSoldOutButton();
    var target = document.querySelector('.product__buy-box') || document.body;
    new MutationObserver(queueSync).observe(target, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    document.addEventListener('change', function (event) {
      if (event.target.matches('select, input[type="radio"]')) queueSync();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSoldOutPopup);
  else initSoldOutPopup();
})();

(function(){var s=document.createElement('style');s.textContent='.bijt-soldout-close{position:absolute!important;top:12px!important;right:14px!important;left:auto!important;width:38px!important;height:38px!important;padding:0!important;margin:0!important;border:0!important;background:transparent!important;color:#fff!important;box-shadow:none!important;transform:none!important}.bijt-soldout-dismiss{background:transparent!important;border:1px solid #555665!important;color:#fff!important}';document.head.appendChild(s);}());

/* Bijt TCG: toon conditie uitsluitend bij singles */
(function () {
  var attempts = 0;

  function syncConditionRow() {
    var facts = document.getElementById('bijt-product-facts');
    if (!facts) {
      if (attempts++ < 40) window.setTimeout(syncConditionRow, 100);
      return;
    }

    var rows = facts.querySelectorAll('li');
    var conditionRow = null;
    var hasCardNumber = false;

    for (var i = 0; i < rows.length; i++) {
      var label = rows[i].querySelector('strong');
      var text = (label ? label.textContent : rows[i].textContent).trim().toLowerCase();
      if (text === 'conditie') conditionRow = rows[i];
      if (text === 'set / kaartnummer') hasCardNumber = true;
    }

    if (conditionRow && !hasCardNumber && conditionRow.parentNode) {
      conditionRow.parentNode.removeChild(conditionRow);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncConditionRow);
  } else {
    syncConditionRow();
  }
}());

/* Bijt TCG: ETB- en accessoirecollecties hebben geen conditieregel */
(function () {
  var attempts = 0;
  function removeCollectionCondition() {
    var nonSingleCollection = /\/collections\/(elite-trainer-boxen|accessoires)\/products\//.test(location.pathname);
    if (!nonSingleCollection) return;
    var facts = document.getElementById('bijt-product-facts');
    if (!facts) {
      if (attempts++ < 40) window.setTimeout(removeCollectionCondition, 100);
      return;
    }
    var rows = facts.querySelectorAll('li');
    for (var i = 0; i < rows.length; i++) {
      var label = rows[i].querySelector('strong');
      if (label && label.textContent.trim().toLowerCase() === 'conditie') {
        rows[i].parentNode.removeChild(rows[i]);
        break;
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', removeCollectionCondition);
  else removeCollectionCondition();
}());

/* Bijt TCG: productconditie uit metafield, standaard Near Mint */
(function () {
  var attempts = 0;
  function syncProductCondition() {
    var facts = document.getElementById('bijt-product-facts');
    if (!facts) {
      if (attempts++ < 40) window.setTimeout(syncProductCondition, 100);
      return;
    }
    var source = document.getElementById('bijt-product-condition');
    var condition = 'Near Mint';
    if (source) {
      try { condition = JSON.parse(source.textContent) || 'Near Mint'; }
      catch (error) { condition = 'Near Mint'; }
    }
    var rows = facts.querySelectorAll('li');
    for (var i = 0; i < rows.length; i++) {
      var label = rows[i].querySelector('strong');
      if (label && label.textContent.trim().toLowerCase() === 'conditie') {
        var value = rows[i].querySelector('span');
        if (value) value.textContent = condition;
        break;
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncProductCondition);
  else syncProductCondition();
}());

/* Bijt TCG: accessoires tonen geen set of kaartnummer */
(function () {
  var attempts = 0;
  function removeAccessoryCardNumber() {
    if (!/\/collections\/accessoires\/products\//.test(location.pathname)) return;
    var facts = document.getElementById('bijt-product-facts');
    if (!facts) {
      if (attempts++ < 40) window.setTimeout(removeAccessoryCardNumber, 100);
      return;
    }
    var rows = facts.querySelectorAll('li');
    for (var i = 0; i < rows.length; i++) {
      var label = rows[i].querySelector('strong');
      if (label && label.textContent.trim().toLowerCase() === 'set / kaartnummer') {
        rows[i].parentNode.removeChild(rows[i]);
        break;
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', removeAccessoryCardNumber);
  else removeAccessoryCardNumber();
}());

/* Bijt TCG: nette accentlijn onder dropdown-collecties */
(function () {
  var style = document.createElement('style');
  style.id = 'bijt-dropdown-underline-fix';
  style.textContent = '#main-header #primary-menu .is-dropdown-submenu-item > .menu-item-link{padding:11px 16px 14px!important}' +
    '#main-header #primary-menu .is-dropdown-submenu-item > .menu-item-link::after{top:auto!important;right:auto!important;bottom:6px!important;left:16px!important;width:0!important;height:2px!important}' +
    '#main-header #primary-menu .is-dropdown-submenu-item > .menu-item-link:hover::after,#main-header #primary-menu .is-dropdown-submenu-item > .menu-item-link:focus-visible::after,#main-header #primary-menu .is-dropdown-submenu-item.menu__active > .menu-item-link::after{width:28px!important}';
  document.head.appendChild(style);
}());

/* Bijt TCG: breadcrumbs, nette productinfo en extra image loading hints */
(function () {
  function addStyles() {
    if (document.getElementById('bijt-optimization-styles')) return;
    var style = document.createElement('style');
    style.id = 'bijt-optimization-styles';
    style.textContent = '.bijt-breadcrumbs{max-width:1120px;margin:18px auto 8px;padding:0 20px;font-family:"Space Grotesk",sans-serif;font-size:13px;color:#aaa6c9}' +
      '.bijt-breadcrumbs ol{display:flex;align-items:center;flex-wrap:wrap;gap:7px;list-style:none;margin:0;padding:0}' +
      '.bijt-breadcrumbs li{display:flex;align-items:center;gap:7px;margin:0;padding:0}' +
      '.bijt-breadcrumbs li:not(:last-child)::after{content:"›";color:#756f99}' +
      '.bijt-breadcrumbs a{color:#c8c4f0;text-decoration:none;transition:color .2s ease}' +
      '.bijt-breadcrumbs a:hover,.bijt-breadcrumbs a:focus-visible{color:#b976ff}' +
      '.bijt-breadcrumbs [aria-current="page"]{color:#f3f1ff}' +
      '@media(max-width:640px){.bijt-breadcrumbs{margin:14px auto 4px;padding:0 16px;font-size:12px}}';
    document.head.appendChild(style);
  }

  function collectionDetails() {
    var path = location.pathname;
    var match = path.match(/\/collections\/([^/]+)/);
    var handle = match ? match[1] : '';
    var names = {
      'all': 'Alle producten',
      'singles': 'Singles',
      'elite-trainer-boxen': 'Elite Trainer Boxen',
      'accessoires': 'Accessoires'
    };
    if (!handle && /\/products\//.test(path)) {
      var title = (document.querySelector('main h1') || {}).textContent || '';
      var labels = Array.prototype.map.call(document.querySelectorAll('#bijt-product-facts strong'), function (item) { return item.textContent.trim().toLowerCase(); });
      if (/elite trainer box/i.test(title)) handle = 'elite-trainer-boxen';
       else if (/ultra pro|sleeve|toploader|deck protector|binder|playmat|deck box|card holder|penny sleeve/i.test(title)) handle = 'accessoires';
      else if (labels.indexOf('conditie') !== -1 || labels.indexOf('set / kaartnummer') !== -1) handle = 'singles';
      else handle = 'accessoires';
    }
    return handle && names[handle] ? { handle: handle, name: names[handle] } : null;
  }

  function addBreadcrumbs() {
    if (document.querySelector('.bijt-breadcrumbs')) return;
    var path = location.pathname;
    var isProduct = /\/products\//.test(path);
    var isCollection = /\/collections\/[^/]+\/?$/.test(path);
    if (!isProduct && !isCollection) return;
    var main = document.querySelector('main');
    var heading = document.querySelector('main h1');
    if (!main || !heading) return;
    var details = collectionDetails();
    var nav = document.createElement('nav');
    nav.className = 'bijt-breadcrumbs';
    nav.setAttribute('aria-label', 'Broodkruimel');
    var items = '<li><a href="/">Home</a></li>';
    if (isProduct && details) items += '<li><a href="/collections/' + details.handle + '">' + details.name + '</a></li>';
    items += '<li><span aria-current="page">' + heading.textContent.trim().replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</span></li>';
    nav.innerHTML = '<ol>' + items + '</ol>';
    main.insertBefore(nav, main.firstElementChild);
  }

  function tidyProductFacts() {
    var facts = document.getElementById('bijt-product-facts');
    if (!facts) return;
    if (!facts.querySelector('li')) facts.style.display = 'none';
  }

  function optimizeHomeImages() {
    if (location.pathname !== '/') return;
    var images = document.querySelectorAll('main img');
    for (var i = 1; i < images.length; i++) {
      images[i].setAttribute('loading', 'lazy');
      images[i].setAttribute('decoding', 'async');
      if (images[i].getBoundingClientRect().top > window.innerHeight) images[i].setAttribute('fetchpriority', 'low');
    }
  }

  function initBijtOptimizations() {
    addStyles();
    addBreadcrumbs();
    optimizeHomeImages();
    window.setTimeout(tidyProductFacts, 350);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBijtOptimizations);
  else initBijtOptimizations();
}());

/* Bijt TCG: pre-launch vertrouwen, conditiegids en live zoeken */
(function () {
  function addLaunchStyles() {
    if (document.getElementById('bijt-launch-styles')) return;
    var style = document.createElement('style');
    style.id = 'bijt-launch-styles';
    style.textContent = '.bijt-product-trust{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-top:14px}' +
      '.bijt-product-trust span{display:flex;align-items:center;justify-content:center;gap:7px;padding:10px 8px;border:1px solid #343044;border-radius:8px;background:#15131f;color:#d8d4ef;font-size:12px;text-align:center}' +
      '.bijt-product-trust b{color:#a95cff;font-size:15px}' +
      '.bijt-condition-link{display:inline-flex;margin-top:8px;color:#b976ff!important;font-size:13px;font-weight:600;text-decoration:none}' +
      '.bijt-condition-link:hover{text-decoration:underline}' +
      '.bijt-guide-modal{position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;padding:20px;background:rgba(5,4,10,.82)}' +
      '.bijt-guide-modal.is-open{display:flex}.bijt-guide-dialog{position:relative;max-width:680px;max-height:85vh;overflow:auto;padding:28px;border:1px solid #51486d;border-radius:14px;background:#14121d;color:#e9e6f8;box-shadow:0 24px 80px rgba(0,0,0,.55)}' +
      '.bijt-guide-dialog h2{margin:0 40px 16px 0;color:#fff;font-size:24px}.bijt-guide-dialog h3{margin:20px 0 5px;color:#c58aff;font-size:17px}.bijt-guide-dialog p{margin:0;color:#c9c5db;line-height:1.65}' +
      '.bijt-guide-close{position:absolute;top:12px;right:14px;width:36px;height:36px;border:0;background:transparent;color:#fff;font-size:28px;cursor:pointer}' +
      '.bijt-search-wrap{position:relative!important}.bijt-predictive{position:absolute;top:calc(100% + 8px);left:0;right:0;z-index:9999;display:none;min-width:300px;overflow:hidden;border:1px solid #3c3650;border-radius:10px;background:#12101a;box-shadow:0 18px 50px rgba(0,0,0,.45)}' +
      '.bijt-predictive.is-open{display:block}.bijt-predictive a{display:flex;align-items:center;gap:11px;padding:10px 12px;color:#ece9fa;text-decoration:none;border-bottom:1px solid #282436}' +
      '.bijt-predictive a:last-child{border-bottom:0}.bijt-predictive a:hover,.bijt-predictive a:focus{background:#201b2d}' +
      '.bijt-predictive img{width:48px;height:48px;object-fit:contain;border-radius:6px;background:#fff}.bijt-predictive strong{display:block;font-size:13px}.bijt-predictive small{display:block;margin-top:3px;color:#bdb8d2}.bijt-predictive-empty{padding:14px;color:#bbb6cc;font-size:13px}' +
      '@media(max-width:640px){.bijt-product-trust{grid-template-columns:1fr}.bijt-predictive{position:fixed;top:70px;left:12px;right:12px;min-width:0}.bijt-guide-dialog{padding:24px 20px}}';
    document.head.appendChild(style);
  }

  function addProductTrust() {
    if (!document.body.classList.contains('template-product') || document.querySelector('.bijt-product-trust')) return;
    var box = document.querySelector('.product__buy-box') || document.querySelector('form[action*="/cart/add"]');
    if (!box) return;
    var trust = document.createElement('div');
    trust.className = 'bijt-product-trust';
    trust.setAttribute('aria-label', 'Voordelen van bestellen bij Bijt TCG');
    trust.innerHTML = '<span><b>✓</b>Veilig betalen</span><span><b>✓</b>Zorgvuldig verpakt</span><span><b>✓</b>Verzonden vanuit Nederland</span>';
    box.parentNode.insertBefore(trust, box.nextSibling);
  }

  function ensureGuideModal() {
    var modal = document.getElementById('bijt-condition-guide');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'bijt-condition-guide';
    modal.className = 'bijt-guide-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'bijt-guide-title');
    modal.innerHTML = '<div class="bijt-guide-dialog"><button class="bijt-guide-close" type="button" aria-label="Conditiegids sluiten">×</button><h2 id="bijt-guide-title">Conditiegids Pokémon-kaarten</h2><h3>Near Mint (NM)</h3><p>Zeer nette staat met hooguit minimale gebruikssporen. Geen duidelijke vouwen, kreuken of zware beschadigingen.</p><h3>Excellent (EX)</h3><p>Nette kaart met lichte rand- of hoekslijtage of enkele oppervlakkige krasjes.</p><h3>Light Played (LP)</h3><p>Zichtbare gebruikssporen, zoals slijtage aan randen en hoeken of lichte krasjes, zonder zware beschadigingen.</p><h3>Played (PL)</h3><p>Duidelijk gebruikte kaart met meerdere zichtbare gebruikssporen, zoals slijtage, krasjes of lichte verkleuring.</p><h3>Goed om te weten</h3><p>De conditie staat bij iedere single in de productinformatie. Heb je een vraag over een specifieke kaart? Neem gerust contact met ons op.</p></div>';
    document.body.appendChild(modal);
    function closeGuide(){modal.classList.remove('is-open'); document.body.style.overflow='';}
    modal.querySelector('.bijt-guide-close').addEventListener('click', closeGuide);
    modal.addEventListener('click', function (event) { if (event.target === modal) closeGuide(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && modal.classList.contains('is-open')) closeGuide(); });
    return modal;
  }

  function addConditionGuide() {
    if (document.querySelector('.bijt-condition-link')) return;
    var rows = document.querySelectorAll('#bijt-product-facts li');
    for (var i = 0; i < rows.length; i++) {
      var label = rows[i].querySelector('strong');
      if (label && label.textContent.trim().toLowerCase() === 'conditie') {
        var link = document.createElement('a');
        link.href = '#bijt-condition-guide';
        link.className = 'bijt-condition-link';
        link.textContent = 'Wat betekenen de condities?';
        link.addEventListener('click', function (event) { event.preventDefault(); var modal = ensureGuideModal(); modal.classList.add('is-open'); document.body.style.overflow='hidden'; modal.querySelector('.bijt-guide-close').focus(); });
        rows[i].appendChild(link);
        break;
      }
    }
  }

  function formatPrice(value) {
    var number = parseFloat(value);
    if (isNaN(number)) return '';
    return '€' + number.toFixed(2).replace('.', ',');
  }

  function initPredictiveSearch() {
    var inputs = document.querySelectorAll('form[action="/search"] input[name="q"], input[type="search"][name="q"]');
    for (var i = 0; i < inputs.length; i++) (function (input) {
      if (input.dataset.bijtPredictive) return;
      input.dataset.bijtPredictive = 'true';
      input.setAttribute('autocomplete', 'off');
      var wrap = input.parentElement;
      wrap.classList.add('bijt-search-wrap');
      var results = document.createElement('div');
      results.className = 'bijt-predictive';
      results.setAttribute('role', 'listbox');
      wrap.appendChild(results);
      var timer;
      input.addEventListener('input', function () {
        window.clearTimeout(timer);
        var query = input.value.trim();
        if (query.length < 2) { results.classList.remove('is-open'); results.innerHTML = ''; return; }
        timer = window.setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5')
            .then(function (response) { return response.json(); })
            .then(function (data) {
              var products = data.resources && data.resources.results ? data.resources.results.products || [] : [];
              results.innerHTML = '';
              if (!products.length) { var empty = document.createElement('div'); empty.className='bijt-predictive-empty'; empty.textContent='Geen producten gevonden'; results.appendChild(empty); }
              for (var p = 0; p < products.length; p++) {
                var product = products[p];
                var item = document.createElement('a'); item.href = product.url; item.setAttribute('role','option');
                var image = document.createElement('img'); image.alt=''; image.loading='lazy'; image.src=(product.featured_image && product.featured_image.url) || product.image || '';
                var text = document.createElement('span'); var title=document.createElement('strong'); title.textContent=product.title; var price=document.createElement('small'); price.textContent=formatPrice(product.price);
                text.appendChild(title); text.appendChild(price); item.appendChild(image); item.appendChild(text); results.appendChild(item);
              }
              results.classList.add('is-open');
            }).catch(function () { results.classList.remove('is-open'); });
        }, 180);
      });
      document.addEventListener('click', function (event) { if (!wrap.contains(event.target)) results.classList.remove('is-open'); });
    }(inputs[i]));
  }

  function initLaunchFeatures() {
    addLaunchStyles();
    addProductTrust();
    initPredictiveSearch();
    window.setTimeout(addConditionGuide, 450);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLaunchFeatures); else initLaunchFeatures();
}());

/* Bijt TCG: consistente Nederlandse productomschrijvingen */
(function () {
  function escapeText(value) { var div=document.createElement('div'); div.textContent=value||''; return div.innerHTML; }
  function updateProductDescription() {
    


    if (!document.body.classList.contains('template-product')) return;
    var description = document.querySelector('.product-description');
    var heading = document.querySelector('main h1');
    if (!description || !heading) return;
    var title = heading.textContent.trim();
    var handleMatch = location.pathname.match(/\/products\/([^/?]+)/);
    var handle = handleMatch ? handleMatch[1] : '';
    var accessoryDescriptions = {
      'pokemon-togepi-105ct-apex-deck-protector-sleeves-pce':'<p><strong>Pokémon Togepi APEX Deck Protector Sleeves</strong></p><p>Geef je Pokémon TCG-deck een vrolijke uitstraling en bescherm je kaarten tijdens het spelen en opbergen.</p><ul><li>105 sleeves van standaardformaat</li><li>Officieel gelicentieerd Pokémon-product</li><li>Stevige APEX-formule voor soepel schudden en langdurig gebruik</li><li>Transparante, glanzende voorkant</li></ul>',
      'pokemon-elite-gengar-105ct-apex-deck-protector-sleeves':'<p><strong>Pokémon Gengar APEX Deck Protector Sleeves</strong></p><p>Bescherm je Pokémon TCG-kaarten met stevige sleeves voorzien van exclusief Gengar-artwork.</p><ul><li>105 sleeves van standaardformaat</li><li>Officieel gelicentieerd Pokémon-product</li><li>Stevige APEX-formule voor soepel schudden en langdurig gebruik</li><li>Transparante, glanzende voorkant</li></ul>',
      'toploader-combo-deckbox-25-sleeves-25-toploaders':'<p><strong>Complete beschermingsset voor je kaarten</strong></p><p>Deze combinatie bevat alles om losse kaarten direct te beschermen en overzichtelijk op te bergen.</p><ul><li>1 transparante opbergbox van archiefveilig polypropyleen</li><li>25 zachte kaarthoezen</li><li>25 toploaders</li></ul>',
      'ultra-pro-graded-card-sleeves-psa':'<p><strong>Bescherming voor graded kaarten</strong></p><p>Deze Ultra Pro sleeves helpen graded kaarten en slabs te beschermen tegen stof, vingerafdrukken en lichte krassen.</p><ul><li>Geschikt voor PSA-formaat graded kaarten</li><li>Transparant materiaal</li><li>Handig voor opslag, presentatie en vervoer</li></ul>',
      'ultra-pro-semi-rigid-card-holders':'<p><strong>Ultra Pro Semi-Rigid Card Holders</strong></p><p>Stevige semi-rigide kaarthouders voor het veilig bewaren en insturen van trading cards naar gradingservices.</p><ul><li>Doos met 200 kaarthouders</li><li>Geschikt voor kaarten tot circa 80,9 × 107,9 mm</li><li>Handige lip van circa 12,7 mm</li></ul>',
      'pokemon-elite-gengar-105ct-apex-deck-protector-sleeves-kopie':'<p><strong>Ultra Pro Soft Card Sleeves</strong></p><p>Transparante zachte sleeves voor Pokémon-, Yu-Gi-Oh!- en andere trading cards.</p><ul><li>100 sleeves per verpakking</li><li>Geschikt voor kaarten tot circa 63,5 × 88,9 mm</li><li>PVC-vrij en zuurvrij</li></ul>'
    };
    if (accessoryDescriptions[handle]) { description.innerHTML=accessoryDescriptions[handle]; return; }
if (false) {    
      description.innerHTML='<p><strong>'+escapeText(title)+'</strong></p><p>Een sealed Pokémon TCG Elite Trainer Box voor verzamelaars en spelers die hun collectie willen uitbreiden met een origineel, ongeopend product.</p><ul><li>Origineel Pokémon TCG-product</li><li>Sealed en ongeopend geleverd</li><li>Geschikt om te verzamelen, te openen of cadeau te geven</li><li>Zorgvuldig verpakt voor veilige verzending</li><li>Verzonden vanuit Nederland</li></ul><p>Bekijk de productfoto’s voor de exacte uitvoering. De inhoud, taal en verpakking kunnen per set verschillen.</p>';
      return;
    }
    var code=''; var rows=document.querySelectorAll('#bijt-product-facts li');
    for(var i=0;i<rows.length;i++){var label=rows[i].querySelector('strong'); if(label&&label.textContent.trim().toLowerCase()==='set / kaartnummer'){var span=rows[i].querySelector('span'); code=span?span.textContent.trim():'';}}
    if (code) description.innerHTML='<p><strong>'+escapeText(title)+'</strong></p><p>Losse Pokémon TCG-kaart voor verzamelaars en spelers.</p><ul><li>Kaartnummer: '+escapeText(code)+'</li><li>Conditie: zie de productinformatie op deze pagina</li><li>Zorgvuldig beschermd en verpakt voor verzending</li></ul><p> </p>';
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',updateProductDescription); else updateProductDescription();
}());

/* Bijt TCG: laatste Nederlandse interface-opruiming */
(function () {
  function cleanupDutchInterface() {
    var checkout = document.querySelector('button[name="checkout"]');
    if (checkout) checkout.textContent = 'Afrekenen';
    if (document.body.classList.contains('template-404')) {
      var main = document.querySelector('main');
      if (main) {
        var paragraph = main.querySelector('p');
        if (paragraph) paragraph.innerHTML = 'De pagina die je zoekt bestaat niet. <a href="/collections/all">Bekijk alle producten</a> of ga terug naar de <a href="/">homepage</a>.';
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cleanupDutchInterface); else cleanupDutchInterface();
}());



/* Bijt TCG: productpagina launch-verfijning */
(function () {
  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function softenSoldOutLabels() {
    if (!document.body.classList.contains('template-product')) return;

    var candidates = Array.from(document.querySelectorAll('button, span, div, p, a')).filter(function (el) {
      var text = cleanText(el.textContent);
      return /^niet op voorraad$/i.test(text) || /^uitverkocht$/i.test(text);
    });

    candidates.forEach(function (el) {
      var isProductCard = !!el.closest('.product-loop-card, .collection__products-grid, [class*=\"product-loop\"]');
      el.textContent = isProductCard ? 'Uitverkocht' : 'Momenteel niet op voorraad';
    });

    var addButton = document.querySelector('button[name=\"add\"], button[type=\"submit\"]');
    if (addButton && /niet op voorraad|uitverkocht/i.test(cleanText(addButton.textContent))) {
      addButton.textContent = 'Momenteel niet op voorraad';
      addButton.setAttribute('aria-label', 'Momenteel niet op voorraad');
    }
  }

  function polishRelatedProducts() {
    if (!document.body.classList.contains('template-product')) return;

    var productLinks = Array.from(document.querySelectorAll('.product-loop-title'));
    var cards = productLinks.map(function (link) {
      return link.closest('.columns') || link.closest('[class*=\"column\"]') || link.closest('.product-loop-card') || link.parentElement;
    }).filter(Boolean).filter(function (card, index, list) {
      return list.indexOf(card) === index;
    });

    if (cards.length < 2) return;

    var soldOutCards = cards.filter(function (card) {
      return /niet op voorraad|uitverkocht/i.test(cleanText(card.textContent));
    });

    if (soldOutCards.length && soldOutCards.length < cards.length) {
      soldOutCards.forEach(function (card) {
        card.style.display = 'none';
        card.setAttribute('aria-hidden', 'true');
      });
    }
  }

  function addProductSummary() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.bijt-product-summary')) return;

    var title = document.querySelector('main h1');
    if (!title) return;

    var titleText = cleanText(title.textContent);
    var path = location.pathname.toLowerCase();
    var summaryText = 'Origineel Pokémon TCG-product, zorgvuldig verpakt en verzonden vanuit Nederland.';

    if (/elite trainer box/i.test(titleText)) {
      summaryText = 'Sealed Pokémon TCG Elite Trainer Box. Origineel product, zorgvuldig verpakt en verzonden vanuit Nederland.';
    } else if (path.indexOf('/collections/singles/') !== -1 || /mep-|kaart|single/i.test(titleText)) {
      summaryText = 'Losse Pokémon TCG-kaart voor verzamelaars en spelers. Zorgvuldig beschermd en verpakt verzonden.';
    } else if (path.indexOf('/collections/accessoires/') !== -1 || /sleeves|toploader|deck protector|card holder/i.test(titleText)) {
      summaryText = 'Accessoire voor het beschermen, bewaren of presenteren van je Pokémon TCG-collectie.';
    }

    var summary = document.createElement('p');
    summary.className = 'bijt-product-summary';
    summary.textContent = summaryText;
    summary.style.margin = '8px 0 14px';
    summary.style.color = '#5f566f';
    summary.style.fontSize = '15px';
    summary.style.lineHeight = '1.55';
    summary.style.maxWidth = '560px';

    title.parentNode.insertBefore(summary, title.nextSibling);
  }

  function runProductPolish() {
    addProductSummary();
    softenSoldOutLabels();
    polishRelatedProducts();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runProductPolish);
  else runProductPolish();
  window.setTimeout(runProductPolish, 700);
  window.setTimeout(runProductPolish, 1800);
})();

/* Bijt TCG: adres minder prominent op zichtbare pagina's */
(function () {
  function replaceInTextNodes(root, replacements) {
    if (!root) return;
    var skip = { SCRIPT: true, STYLE: true, NOSCRIPT: true, TEXTAREA: true, INPUT: true };

    function walk(node) {
      if (!node) return;
      if (node.nodeType === 3) {
        var value = node.nodeValue || '';
        replacements.forEach(function (pair) {
          value = value.replace(pair[0], pair[1]);
        });
        if (value !== node.nodeValue) node.nodeValue = value;
        return;
      }
      if (node.nodeType !== 1 || skip[node.nodeName]) return;
      var children = Array.prototype.slice.call(node.childNodes || []);
      children.forEach(walk);
    }

    walk(root);
  }

  function softenAddressVisibility() { return;
    if (!document.body) return;
    replaceInTextNodes(document.body, [
      [/Bijt TCG\s*Wijkersloot 7D\s*3961 MN,?\s*Nederland\s*/gi, 'Bijt TCG '],
      [/Vestigings- en retouradres:\s*Wijkersloot 7D,?\s*3961 MN,?\s*Nederland/gi, 'Bedrijfsgegevens: Bijt TCG, Nederland'],
      [/terug te sturen naar Bijt TCG,\s*Wijkersloot 7D,?\s*3961 MN,?\s*Nederland\./gi, 'terug te sturen naar het retouradres dat je na je retourmelding ontvangt.'],
      [/Wijkersloot 7D,?\s*3961 MN,?\s*Nederland/gi, 'Nederland'],
      [/Wijkersloot 7D/gi, ''],
      [/3961 MN,?\s*Nederland/gi, 'Nederland']
    ]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', softenAddressVisibility);
  else softenAddressVisibility();
  window.setTimeout(softenAddressVisibility, 700);
  window.setTimeout(softenAddressVisibility, 1800);
})();

/* Bijt TCG: launch polish top 5 v2 */
(function () {
  window.__bijtLaunchPolishV2 = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function cleanText(el) {
    return (el && el.innerText ? el.innerText : '').replace(/\s+/g, ' ').trim();
  }

  function textNodes(root) {
    var nodes = [];
    var skip = { SCRIPT: true, STYLE: true, NOSCRIPT: true, TEXTAREA: true, INPUT: true };
    (function walk(node) {
      if (!node) return;
      if (node.nodeType === 3) {
        nodes.push(node);
        return;
      }
      if (node.nodeType !== 1 || skip[node.nodeName]) return;
      Array.prototype.slice.call(node.childNodes || []).forEach(walk);
    })(root);
    return nodes;
  }

  function fixLogoH1() {
    Array.prototype.slice.call(document.querySelectorAll('h1')).forEach(function (h1) {
      if (cleanText(h1) !== '') return;
      var div = document.createElement('div');
      Array.prototype.slice.call(h1.attributes).forEach(function (attr) {
        div.setAttribute(attr.name, attr.value);
      });
      div.className = (div.className ? div.className + ' ' : '') + 'bijt-replaced-empty-h1';
      div.setAttribute('data-bijt-replaced-empty-h1', 'true');
      while (h1.firstChild) div.appendChild(h1.firstChild);
      h1.parentNode && h1.parentNode.replaceChild(div, h1);
    });
  }

  function fixHomepageAccessories() {
    if (!document.body || !document.body.classList.contains('template-index')) return;
    Array.prototype.slice.call(document.querySelectorAll('h2')).forEach(function (h2) {
      if (cleanText(h2).toLowerCase() !== 'pokémon accessoires') return;
      var section = h2.closest('.shopify-section, div.section, section') || h2.parentElement;
      if (section) {
        section.style.display = 'none';
        section.setAttribute('aria-hidden', 'true');
        section.setAttribute('data-bijt-hidden-duplicate-accessories', 'true');
      }
    });
  }

  function fixSinglesTitle() {
    if (window.location.pathname.replace(/\/$/, '') !== '/collections/singles') return;
    Array.prototype.slice.call(document.querySelectorAll('h1')).forEach(function (h1) {
      if (/^Singles\s+Engels$/i.test(cleanText(h1))) h1.textContent = 'Singles';
    });
    document.title = document.title.replace(/Singles Engels/gi, 'Singles');
  }

  function fixContactText() {
    if (window.location.pathname !== '/pages/contact') return;
    var root = document.querySelector('main') || document.body;
    var nodes = textNodes(root);
    nodes.forEach(function (node) {
      if (/^\s*Bedrijfs- en retourgegevens\s*$/.test(node.nodeValue || '')) {
        node.nodeValue = 'Bedrijfsgegevens';
      }
    });
    var start = -1;
    for (var i = 0; i < nodes.length; i++) {
      if (/^\s*Bijt TCG\s*$/.test(nodes[i].nodeValue || '')) {
        start = i;
        break;
      }
    }
    if (start >= 0) {
      for (var j = start + 1; j < Math.min(nodes.length, start + 10); j++) {
        if (/^\s*Nederland\s*$/.test(nodes[j].nodeValue || '')) {
          nodes[j].nodeValue = 'Bijt TCG is gevestigd in Nederland. Retourinstructies ontvang je na je retourmelding.';
          break;
        }
      }
    }
  }

  function fixDuplicateGoogleTags() {
    var seen = {};
    Array.prototype.slice.call(document.querySelectorAll('script[src*="googletagmanager.com/gtag/js"]')).forEach(function (script) {
      var src = script.getAttribute('src') || '';
      var match = src.match(/[?&]id=([^&]+)/);
      var id = match ? decodeURIComponent(match[1]) : src;
      if (seen[id]) {
        script.parentNode && script.parentNode.removeChild(script);
      } else {
        seen[id] = true;
      }
    });
  }

  function run() {
    fixLogoH1();
    fixHomepageAccessories();
    fixSinglesTitle();
    fixContactText();
    fixDuplicateGoogleTags();
  }

  ready(run);
  window.setTimeout(run, 600);
  window.setTimeout(run, 1600);
  window.setTimeout(run, 3200);
})();



/* Bijt TCG remaining marker */
(function(){document.documentElement.setAttribute('data-bijt-remaining-marker','yes');})();

/* Bijt TCG: subtiele quick-add winkelwagenknop */
(function(){
  function addStyle(){
    if(document.getElementById("bijt-quick-add-subtle")) return;
    var s=document.createElement("style");
    s.id="bijt-quick-add-subtle";
    s.textContent=".bijt-quick-add{width:38px;min-width:38px;height:38px;min-height:38px;margin:10px 0 0 auto;padding:0;border-radius:50%;font-size:18px;line-height:1;flex:0 0 38px;box-sizing:border-box}.bijt-quick-add:hover,.bijt-quick-add:focus-visible{transform:translateY(-1px)}@media(max-width:749px){.bijt-quick-add{width:36px;min-width:36px;height:36px;min-height:36px;flex-basis:36px;font-size:17px}}";
    document.head.appendChild(s);
  }
  function addIcons(){
    var b=document.querySelectorAll(".bijt-quick-add");
    for(var i=0;i<b.length;i++){ if(!b[i].getAttribute("data-bijt-icon")){ b[i].textContent=String.fromCodePoint(128722); b[i].setAttribute("data-bijt-icon","1"); } }
  }
  function run(){ addStyle(); addIcons(); }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",run); else run();
  setTimeout(run,800); setTimeout(run,1800);
  new MutationObserver(run).observe(document.documentElement,{childList:true,subtree:true});
})();

/* Bijt TCG: quick-add knoppen volledig verwijderen */
(function(){
  function removeQuickAdd(){
    var buttons=document.querySelectorAll(".bijt-quick-add");
    for(var i=0;i<buttons.length;i++){
      if(buttons[i] && buttons[i].parentNode) buttons[i].parentNode.removeChild(buttons[i]);
    }
    if(!document.getElementById("bijt-remove-quick-add")){
      var style=document.createElement("style");
      style.id="bijt-remove-quick-add";
      style.textContent=".bijt-quick-add{display:none!important}";
      document.head.appendChild(style);
    }
  }
  removeQuickAdd();
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",removeQuickAdd);
  setTimeout(removeQuickAdd,600);
  setTimeout(removeQuickAdd,1600);
  new MutationObserver(removeQuickAdd).observe(document.documentElement,{childList:true,subtree:true});
})();


/* Bijt TCG Singles hoveraccent */
(function(){if(window.bijtSinglesHover)return;window.bijtSinglesHover=1;var all=document.querySelectorAll('.menu-item-link,.mobile-menu-link');for(var i=0;i<all.length;i++){var a=all[i];if((a.getAttribute('href')||'').indexOf('/collections/singles')===0){a.addEventListener('mouseenter',function(){this.style.color='#7c3aed';this.style.borderColor='#7c3aed';this.style.textDecorationColor='#7c3aed';});a.addEventListener('mouseleave',function(){this.style.removeProperty('color');this.style.removeProperty('border-color');this.style.removeProperty('text-decoration-color');});}}})();

/* Bijt TCG: Singles hover cache refresh */
/* Bijt TCG: verwijder uitverkochte aanbevelingen volledig. */
(function () {
  function removeRelatedProducts() {
    var headings = Array.prototype.slice.call(document.querySelectorAll('h2, h3, h4'));
    headings.forEach(function (heading) {
      if (!/Misschien vind je dit ook leuk|You May Also Like/i.test(heading.innerText || '')) return;
      var section = heading.closest('.shopify-section, section, div.section') || heading.parentElement;
      if (section) section.remove();
    });
    Array.prototype.slice.call(document.querySelectorAll('.bijt-rec-stock-note')).forEach(function (node) { node.remove(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', removeRelatedProducts);
  else removeRelatedProducts();
  window.setTimeout(removeRelatedProducts, 900);
   
/* Bijt TCG: hide card-only product facts on accessories */
(function(){
  function hideAccessoryFacts(){
    var path=location.pathname;
    var title=(document.querySelector('main h1,h1')||{}).textContent||'';
    if(!/\/products\//.test(path)||!/ultra pro|sleeve|toploader|deck protector|binder|playmat|deck box|card holder|penny sleeve/i.test(title)) return;
    var box=document.querySelector('#bijt-product-facts');
    if(!box) return;
    Array.prototype.forEach.call(box.querySelectorAll('li'),function(row){
      var label=(row.querySelector('strong')||{}).textContent||'';
      if(/conditie|set \/ kaartnummer/i.test(label)) row.style.display='none';
    });
  }
  hideAccessoryFacts();
  document.addEventListener('DOMContentLoaded',hideAccessoryFacts);
  window.setTimeout(hideAccessoryFacts,500);
  window.setTimeout(hideAccessoryFacts,1500);
})();

/* Bijt TCG: hide card-only product facts on accessories */
(function(){
  function hideAccessoryFacts(){
    var path=location.pathname;
    var title=(document.querySelector('main h1,h1')||{}).textContent||'';
    if(!/\/products\//.test(path)||!/ultra pro|sleeve|toploader|deck protector|binder|playmat|deck box|card holder|penny sleeve/i.test(title)) return;
    var box=document.querySelector('#bijt-product-facts');
    if(!box) return;
    Array.prototype.forEach.call(box.querySelectorAll('li'),function(row){
      var label=(row.querySelector('strong')||{}).textContent||'';
      if(/conditie|set \/ kaartnummer/i.test(label)) row.style.display='none';
    });
  }
  hideAccessoryFacts();
  document.addEventListener('DOMContentLoaded',hideAccessoryFacts);
  window.setTimeout(hideAccessoryFacts,500);
  window.setTimeout(hideAccessoryFacts,1500);
})();

})();



